import { render, staticRenderFns } from "./FollowUpPatientStep1Component.vue?vue&type=template&id=1f60136f&scoped=true&"
import script from "./FollowUpPatientStep1Component.vue?vue&type=script&lang=js&"
export * from "./FollowUpPatientStep1Component.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpPatientStep1Component.vue?vue&type=style&index=0&id=1f60136f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f60136f",
  null
  
)

export default component.exports